import { useDropzone } from 'react-dropzone';
import { toast } from "react-toastify";
import _ from "lodash";

const MAX_FILE_SIZE_MB = 1;
const MAX_FILE_SIZE_BYTES = MAX_FILE_SIZE_MB * 1024 * 1024;

export function GetDz(key, uploadFile, opts) {
    if (!opts) {
        opts = {};
    }

    let defaultOpts = {
        noClick: true,
        noKeyboard: true,
        multiple: true,
        maxSize: MAX_FILE_SIZE_BYTES,
        accept: {
            'image/png': ['.png'],
            'image/jpeg': ['.jpg', '.jpeg'],
            'image/gif': ['.gif'],
            'image/webp': ['.webp'],
            'image/heic': ['.heic'],
            'video/mp4': ['.mp4'],
            'video/quicktime': ['.mov'],
            'video/webm': ['.webm'],
            'application/pdf': ['.pdf']
        },
        onDropRejected: function (files, event) {
            const isTooLarge = files.some(f => f.errors && f.errors.some(e => e.code === 'file-too-large'));
            if (isTooLarge) {
                toast(`File exceeds the maximum allowed size of ${MAX_FILE_SIZE_MB}MB`, { position: "top-center", type: "error" });
            } else {
                toast("Could not upload file", { position: "top-center", type: "error" });
            }
        },
        onDropAccepted: function (files, event) {
            _.forEach(files, function (file, k) {
                uploadFile(key, file);
            })
        }
    };

    const finalOpts = Object.assign(defaultOpts, opts);
    return useDropzone(finalOpts)
}